export const clients = [
  {
    id: 1,
    name: "MASHAREA ALGGAD TRADING EST",
  },
  {
    id: 2,
    name: "Aywa Fabrication wll",
  },
  {
    id: 3,
    name: "مؤسسة اعمال الخليج للدعاية و الاعلان استاذ احمد",
  },
  {
    id: 4,
    name: "مؤسسة قمة البروده التجارية",
  },
  {
    id: 5,
    name: "شركة دييلوبمنت ريسورس",
  },
  {
    id: 6,
    name: "مؤسسة بيد روز للهدايا",
  },
  {
    id: 7,
    name: "وكالة الالهام الراقي للدعاية والاعلان",
  },
  {
    id: 8,
    name: "مؤسسه ركن المحروسه للدعايه والاعلان",
  },
  {
    id: 9,
    name: "ميتال ارت بلس",
  },
];